import * as React from 'react';

export function Analyze(
  props: React.HTMLAttributes<SVGSVGElement> & { label: string },
) {
  return (
    <svg
      aria-label={props.label}
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="navigation-icon-analyze"
      {...props}
    >
      <path
        d="M0.5 7C0.5 3.68629 3.18629 1 6.5 1H14.5C17.8137 1 20.5 3.68629 20.5 7V15C20.5 18.3137 17.8137 21 14.5 21H6.5C3.18629 21 0.5 18.3137 0.5 15V7Z"
        fill="url(#paint0_linear_8981_5567)"
      />
      <g filter="url(#filter0_bi_8981_5567)">
        <path
          d="M10.4952 15.0448L6.66119 20.952C6.55599 21.1141 6.5 21.3032 6.5 21.4964V23.0003C6.5 23.5526 6.94772 24.0003 7.5 24.0003H21.5C22.6046 24.0003 23.5 23.1049 23.5 22.0003V8.48713C23.5 7.48244 22.1845 7.10515 21.652 7.95713L16.5 16.2004C16.2192 16.6495 15.637 16.8019 15.1723 16.5478L11.8136 14.7118C11.3547 14.4609 10.7799 14.6061 10.4952 15.0448Z"
          fill="white"
          fillOpacity="0.5"
        />
        <path
          d="M7.08059 21.2242L10.9146 15.317C11.057 15.0977 11.3443 15.0251 11.5738 15.1505L14.9325 16.9866C15.6296 17.3677 16.5029 17.1391 16.924 16.4654L22.076 8.22213C22.3422 7.79614 23 7.98478 23 8.48713V22.0003C23 22.8288 22.3284 23.5003 21.5 23.5003H7.5C7.22386 23.5003 7 23.2765 7 23.0003V21.4964C7 21.3998 7.02799 21.3052 7.08059 21.2242Z"
          stroke="white"
          strokeOpacity="0.2"
        />
      </g>
      <defs>
        <filter
          id="filter0_bi_8981_5567"
          x="5"
          y="5.98535"
          width="20"
          height="19.5146"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="0.75" />
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_8981_5567"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_backgroundBlur_8981_5567"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="0.5" />
          <feGaussianBlur stdDeviation="0.25" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect2_innerShadow_8981_5567"
          />
        </filter>
        <linearGradient
          id="paint0_linear_8981_5567"
          x1="10.5"
          y1="1"
          x2="10.5"
          y2="21"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#439EFF" stopOpacity="0" />
          <stop offset="1" stopColor="#3A99FF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
